__webpack_require__.p = "/energy-calculator/";